<template>
  <CarouselSelector
    v-if="games.length"
    v-model="valueModel"
    type="game"
    variant="small"
    :label="$$t('Games', 'games_label')"
    :items="games"
    class="mb-4"
    hide-item-title
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { prop } from '@/utils/factories';
import { translate } from '@/mixins/translate';
import CarouselSelector from '@/components/common/CarouselSelector';

export default {
  components: {
    CarouselSelector,
  },
  mixins: [translate('_web_filters')],

  props: {
    value: prop(null),
    label: prop(String),
  },

  computed: {
    // TODO: Use mapState
    ...mapGetters(['games']),
    valueModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },

  created() {
    this.fetchGames();
  },

  methods: {
    ...mapActions(['fetchGames']),
  },
};
</script>
